module.exports = __webpack_public_path__ + "img/63.4e3b0cc.png";